
export default[
    {
        show(row,extra){
            return row.shbj==='1'
        },
        tag:'my-btn',
        type:'detail',
        text:'详情',
        click(row,extra){
            
        }
    }
]